export enum SearchArea {
  Message = 'message',
  Node = 'node',
  User = 'user'
}
